<vs-form-field
  *ngIf="showHidden || !hidden || required"
  [config]="{ label: dimension.title + (required ? '' : ' (optional)') + ':' }"
  appearance="vertical"
>
  <!-- Scalar dimension: number input -->
  <vs-input-container *ngIf="dimension.isScalar">
    <input
      #numberInput
      type="number"
      [formControl]="formControl"
      [required]="required"
      (wheel)="$event.ctrlKey ? null : numberInput.blur()"
      (blur)="onTouched()"
    />
  </vs-input-container>

  <!-- Categorical dimension: select from elements -->
  <vs-select
    *ngIf="!dimension.isScalar"
    class="w-full rounded-md border border-[lightgray] px-3 py-[6px] pt-[6px]"
    [formControl]="formControl"
    [disabled]="isLoading"
    (blur)="onTouched()"
  >
    <li *ngFor="let element of elements" vs-select-option [value]="element.id">
      {{ element.title }}
    </li>
  </vs-select>

  <span class="text-danger" slot="hint" *ngIf="formControl.touched && formControl.hasError('required')">
    {{ dimension.title }} must have a value
  </span>
</vs-form-field>
